import 'reflect-metadata';
import {
  container,
  instancePerContainerCachingFactory,
  registry,
} from 'tsyringe';
import {
  kNameOfTesterWindowService,
  ITesterWindowService,
} from 'app-core/src/interfaces/tester-window-service.interface';
import { LoggerService } from 'app-core/src/services/logger.service';
import { WindowsTunnelDataService } from '../shared/services/windows-tunnel-data.service';
import { TesterController } from './tester.controller';
import './tester.scss';

// -----------------------------------------------------------------------------
@registry([
  {
    token: kNameOfTesterWindowService,
    useFactory: instancePerContainerCachingFactory<ITesterWindowService>(
      (c) => {
        const tunnelDataService = c.resolve(WindowsTunnelDataService);
        return tunnelDataService.get(kNameOfTesterWindowService);
      },
    ),
  },
])
class TesterRegistry {}

// -----------------------------------------------------------------------------
const startup = () => {
  LoggerService.setup('Overwolf Notifications Tester');
  const controller = container.resolve(TesterController);
  controller.run();
};

startup();
